import script from "./BasicLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&setup=true&lang=ts"

import "./BasicLayout.vue?vue&type=style&index=0&id=26ae8ed0&lang=scss"

const __exports__ = script;

export default __exports__